package io.curity.ssi.jose

import io.curity.ssi.crypto.NodeJoseKeyStore
import io.curity.ssi.crypto.VerificationKeySet

data class DefaultVerificationKeySet(
    override val keyStore: NodeJoseKeyStore
): VerificationKeySet